import { inject } from 'aurelia-framework';
import { AccountAdminAPI } from '../../services/admin/accountAdminAPI';
import { AuthService } from '../../services/authService';
import { Router } from 'aurelia-router';


@inject(AuthService, Router, AccountAdminAPI)
export class Videos {
    constructor(authService, router, api) {
        this.authService = authService;
        this.router = router;
        this.api = api;
        this.search = null;
        this.searchTemp = null;
        this.magnfi_only = false;
        this.loading = true;
        this.id = null;
        this.email = null;
    }

    activate(params) {
        this.account_owner_id = params.account_owner_id;
        this.whitelabel_id = params.whitelabel_id;
        this.id = params.account_owner_id;

        if(this.id)
            this.api.getUserData(this.id,this.authService.getUser().token,this.saveLoadSuccess.bind(this),this.saveLoadError.bind(this));
    }

    saveLoadError(msg) {
        console.log
        // this.userMessageService.setUserError('user', msg);
        this.loading = false;
      }
    saveLoadSuccess(data) {
        this.loading = false;
        this.setData(data);
    }
    attached() {
        this.requestList.activate(this.account_owner_id, this.magnfi_only ? "NONE" : this.whitelabel_id, this.search);
        this.submissionList.activate(this.account_owner_id, this.magnfi_only ? "NONE" : this.whitelabel_id, this.search);
        this.brandVideoList.activate(this.account_owner_id, this.magnfi_only ? "NONE" : this.whitelabel_id, this.search);
        this.videoEmailList.activate(this.account_owner_id, this.magnfi_only ? "NONE" : this.whitelabel_id, this.search);
        this.videoMessageList.activate(this.account_owner_id, this.magnfi_only ? "NONE" : this.whitelabel_id, this.search);
        this.caseStudyList.activate(this.account_owner_id, this.magnfi_only ? "NONE" : this.whitelabel_id, this.search);
    }

    handleKeypress(event) {
        if (event.keyCode == 13) {
            this.search = this.searchTemp;
            this.attached();
            //event.preventDefault();
            return false;
        }

        return true;
    }

    search_user() {
        this.search = this.searchTemp;
        this.attached();
    }
    getUserData() {
        var data = {
          'id': this.id,
          'email': this.email,
        };
    
        return data;
      }
    setData(data) {
    this.email = data.user.email;
    }
}
